import { LOCALE_UZ } from './locale.constants';
import { YANDEX_API_KEY as ENV_YANDEX_API_KEY } from '../../config/environment';

export const DEFAULT_LOCALE = LOCALE_UZ;
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 20;
export const DEFAULT_LIMIT_10 = 10;
export const DEFAULT_LIMIT_100 = 100;

// Maps Configuration - now imported from environment config
export const YANDEX_API_KEY = ENV_YANDEX_API_KEY;
